import axios from 'axios'

const API_URL = process.env.VUE_APP_HOST + '/api/emailtemplate'


let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
  access_token = process.env.VUE_APP_TOKEN;
  if (!access_token) {
    console.log(window.location.hash)
    var queries = window.location.hash.split("access_token=")
    if (queries.length > 1) {
      access_token = queries[1].split("&")[0]
      if (access_token) {
        let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
        localStorage.setItem('session-authorization', auth);
      }
    }
  }
}
else {
  access_token = JSON.parse(auth).access_token;
}

let headers = {
  headers: {
    'Authorization': `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  }
};


export const emailTemplateApi = {
    getAll: async () => {
        const response = await axios.get(API_URL, headers)
        return response.data
    },
    create: async (template) => {
        const response = await axios.post(API_URL, template, headers)
        return response.data
    },
    update: async (id, template) => {
        const response = await axios.put(`${API_URL}/${id}`, template, headers)
        return response.data
    },
    delete: async (id) => {
        await axios.delete(`${API_URL}/${id}`, headers)
    },
    trigger: async (id) => {
        await axios.post(`${API_URL}/${id}/trigger`, {}, headers)
    }
}

